/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import { savePGAItemField } from '../api/setFormData'
import { pgaTypes } from '../formSections/pga/constantsPGA'

const initialState = {
  loading: true,
  fdaNumber: 0,
  fdaDescription: 'Could not find a FDA Description'
}

export default function FDAReducerWithMerchandiseId(totallyUniquePGAId) {
  return function FDAReducer(state = initialState, action) {
    let pgaGuid = action.pgaGuid;
    switch (action.type) {
      case `INITIALIZE_VALUES_FDA_${totallyUniquePGAId}`: {
        return Object.assign({}, state, { ...action.payload }, { loading: false } ,{pgaTemplates : action.templates} )
      }

      case `TOGGLE_FDA_${totallyUniquePGAId}`: {
        if (action.payload.activeFDAMerchandiseId === null) {
          return { activeFDAMerchandiseId: null, loading: true }
        } else {
          return Object.assign({}, state, {
            ...action.payload
          })
        }
      }
      case `UPDATE_FDA_FIELD_${totallyUniquePGAId}`: {
        let newItem = Object.assign({}, state[action.field])
        console.error('sgredgretate: ', state);
        newItem.value = action.payload
        return Object.assign({}, state, { [action.field]: newItem })
      }
      case `COPY_FDA_FIELD_${totallyUniquePGAId}`: {
        savePGAItemField(pgaGuid, action.pgaItems,action.merchandiseId,pgaTypes.DISCLAIM_PGA,{isPgaCopy:true})
        return Object.assign({}, {
          pgaTemplates:state.pgaTemplates,loading: state.loading, merchandiseId: state.merchandiseId
        }, { ...action.payload }, { loading: false }/*, {pgaTemplates : null}*/)
      }
      case `SAVE_FDA_FIELD_${totallyUniquePGAId}`: {
        savePGAItemField(pgaGuid, 
          [state[action.field]],
          action.merchandiseId,
          pgaTypes.DISCLAIM_PGA
        )
        return state
      }
      default:
        return state
    }
  }
}
